import {useEffect, useRef} from "react";
import useApiQuery from "../ApiQuery/UseApiQuery";
import {
    defUserPreference,
    IDomainPreference,
    ReduxStateInt,
    setDomainPreference,
    setUserPreference
} from "../Reducer/GlobalReducer";
import {useDispatch, useSelector} from "react-redux";

export default function PrefLoader()
{
    const dataLoadPref = useRef(null)
    const [ldrLoadPref,rsLoadPref,exLoadPref] = useApiQuery("/ref/pref/load","post",dataLoadPref);
    const dispatch = useDispatch()
    const prefDomainMain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })
    const prefUserMain = useSelector((state: ReduxStateInt) => {
        return state.prefUser
    })

    const auth = useSelector((state: ReduxStateInt) => {
        return state.authToken
    })

    const isLogin = useSelector((state: ReduxStateInt) => {
        return state.isLogin
    })


    useEffect(()=>{
        //console.log("load preference")
        exLoadPref().then((e)=>{

            const start:IDomainPreference = {...prefDomainMain, stillLoad: false}
            if(e?.success)
            {
                const prefDomain = e?.payload?.prefDomain
                if(prefDomain)
                {
                    //console.log("prefDomain", prefDomain)
                    const x = parseObject(start, prefDomain)

                    //console.log("set domain",x)

                    dispatch(setDomainPreference(x))

                } else             dispatch(setDomainPreference(start))




                const prefUser = e?.payload?.prefUser
                if(prefUser)
                {
                    //console.log("prefUser", prefUser)
                    const x = parseObject({...prefUserMain}, prefUser)

                    dispatch(setUserPreference(x))


                } else dispatch(setUserPreference(defUserPreference))


                return

            }


        })

    },[auth,dataLoadPref,isLogin])



    const parseObject =(obj:any, val:any)=>{
        //console.log("obj", obj)
        if(typeof obj !== "object" || typeof val !=="object") return obj
        Object.keys(obj)?.forEach((key)=>{
            if(val[key] !== undefined){
                //console.log("type key", key,typeof obj[key])
                if(typeof obj[key]=== "boolean")
                {
                    const textVal = val[key]?.toString()
                    obj[key] = !textVal?.match(/^0$/ui)
                    return
                }
                obj[key] = val[key]
            }
        })

        Object.keys(val)?.forEach((key)=>{
            //console.log("key " , key ,obj[key],obj[key] === undefined)
            if(obj[key] === undefined)obj[key] = val[key]
        })

        return obj

    }


    return null
}